const checkDRGValidationFrontend = (nodes, validation, clients) => {
    let lookupDrgError;
    let lookupDrgRemoved;
    let lookupClients;

    const hasDRGError = validation.find(issue => issue.code === 'DATA_INVALID');
    if (hasDRGError) {
        lookupDrgError = hasDRGError?.detail.reduce((acc, item) => {
            acc[item?.drg_id] = item;
            return acc;
        }, {});
    }

    const hasDRGRemoved = validation.find(issue => (issue.code === 'DRG_NOT_FOUND' || issue.code === 'DATA_FETCH_FAILED'));
    if (hasDRGRemoved) {
        lookupDrgRemoved = hasDRGRemoved?.detail.reduce((acc, item) => {
            acc[item?.drg_id] = item;
            return acc;
        }, {});
    }

    // const hasClientInvalid = validation.find(issue => issue.code === 'CLIENT_INVALID');
    // if (hasClientInvalid) {
    //     lookupClients = hasClientInvalid?.detail.reduce((acc, item) => {
    //         acc[item?.client_name] = item;
    //         return acc;
    //     }, {});
    // }

    lookupClients = clients.reduce((acc, item) => {
        acc[item?.client_name] = item;
        return acc;
    }, {});

    const updated_nodes = nodes.map(node => {
        if (node.type === 'data' && node?.data?.general_properties?.drg?.id) {
            const drg_id = node?.data?.general_properties?.drg?.id;
            let drg_validation = [];
            let error_text = node?.data?.error_text.filter(err => (err !== 'DRG is unavailable.' && err !== 'DRG is invalid.')); // clean issue ที่ไม่พบออก
            if (hasDRGError) {
                const hasIssue = lookupDrgError[drg_id];
                if (hasIssue) {
                    error_text = error_text.filter(err => err !== lookupDrgError[drg_id]?.error_text);
                    error_text.push(lookupDrgError[drg_id]?.error_text);
                    drg_validation.push({
                        code: 'DATA_INVALID',
                        summary: `Has data invalid.`,
                        detail: [
                            {
                                drg_id: lookupDrgError[drg_id]?.drg_id,
                                error_text: lookupDrgError[drg_id]?.error_text
                            }
                        ]
                    })
                }
            }
            if (hasDRGRemoved) {
                const hasIssue = lookupDrgRemoved[drg_id];
                if (hasIssue) {
                    error_text = error_text.filter(err => err !== lookupDrgRemoved[drg_id]?.error_text);
                    error_text.push(lookupDrgRemoved[drg_id]?.error_text);
                    drg_validation.push({
                        code: 'DRG_NOT_FOUND',
                        summary: `Invalid DRG reference.`,
                        detail: [
                            {
                                drg_id: lookupDrgRemoved[drg_id]?.drg_id,
                                error_text: lookupDrgRemoved[drg_id]?.error_text
                            }
                        ]
                    })
                }

            }
            // console.log('drg_validation', drg_validation)
            return {
                ...node,
                data: {
                    ...node.data,
                    error: error_text.length > 0,
                    error_text: error_text,
                    general_properties: {
                        ...node.data.general_properties,
                        action: node.data.general_properties.action || '',
                        drg: {
                            ...node.data.general_properties.drg,
                            validation: drg_validation
                        }
                    }
                }
            }
        } else if ((node.type === 'application' || node.type === 'restfulapi') && node?.data?.general_properties?.name?.client_name) {
            const client_name = node?.data?.general_properties?.name?.client_name;
            const app_type = node?.data?.general_properties?.name?.app_type;
            let error_text = node?.data?.error_text || [];
            error_text = error_text.filter(err => (
                err !== 'Client is unavailable.'
                && err !== 'Client no longer available. Please select another.'
            ));
            const isClient = lookupClients[client_name]?.client_name === client_name;
            const isAppType = lookupClients[client_name]?.app_type === app_type;
            if (!isClient || !isAppType) {
                error_text.push('Client no longer available. Please select another.');
            }
            return {
                ...node,
                data: {
                    ...node.data,
                    error: error_text.length > 0,
                    error_text: error_text
                }
            }
        } else {
            return node;
        }
    })

    return updated_nodes;

};

export default checkDRGValidationFrontend;